import useTheme from "@mui/material/styles/useTheme";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React from "react";
import ShowPinIcon from "../icon/toolbar/ShowPinIcon";
import IconButton3D from "./IconButton3D";

const TogglePins = observer(() => {
	const { palette } = useTheme();	
	const secondary = palette.NavListItemSelectedBG;
	const rootStore = useStore();
	const { threeDStore: { modelViewerStore } } = rootStore;
	const { annotationsVisible, setAnnotationsVisible } = modelViewerStore;
	const { threeDStore: { allowPins } } = rootStore;

	if (!allowPins) {
		return null;
	}

	return (
		<IconButton3D 
			onClick={() => {
				setAnnotationsVisible(!annotationsVisible);
			}}
			res={annotationsVisible ? "3DViewPinHide" : "3DViewPin"}
			sx={{
				backgroundColor : annotationsVisible ? secondary : "transparent",
			}}
		>
			<ShowPinIcon
				color={annotationsVisible ? "primary" : "inherit"} 
				fillCurrentColor
			/>
		</IconButton3D>
	);
});

export default TogglePins;